import { LitElement, html, utils } from '@hh/global.js'

class HHHeader extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    // basically, try a couple times to see if global e has loaded on the page
    // if it has, add a bit of an offset to the header to account for the global e banner
    // if it hasn't/you've tried for more than 10 sec, don't add the offset
    this.globalEInit = false
    this.setIntervalTries = 0
    this.time = setInterval(() => {
      this.setIntervalTries++
      if (document.querySelector('#FreeShippingBanner') != undefined) {
        this.globalEInit = true
        this.onScrollHandler()
        clearInterval(this.time)
        window.addEventListener('scroll', this.onScrollHandler, {
          passive: true,
        })
      } else if (this.setIntervalTries > 300) {
        clearInterval(this.time)
      }
    }, 100)

    if (document.body.clientWidth !== window.innerWidth) {
      document.documentElement.classList.add('has-scrollbar')
      const scrollbarWidth =
        window.innerWidth - document.body.getBoundingClientRect()['width']
      document.documentElement.style.setProperty(
        `--hh-scrollbar-width`,
        `${scrollbarWidth}px`
      )
      this.style.setProperty(`--hh-scrollbar-width`, `${scrollbarWidth}px`)
    }

    this.toggleOverflowHidden = () => {
      if (this.querySelectorAll('hh-details-module[is-open]').length === 0) {
        document.documentElement.classList.remove('overflow-hidden')
        return
      }
      document.documentElement.classList.add('overflow-hidden')
    }
    this.addEventListener('mouseleave', this.toggleOverflowHidden)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
    this.removeEventListener('mouseleave', this.toggleOverflowHidden)
  }

  onScrollHandler() {
    if (window.scrollY == 0) {
      document.querySelector('.js-header').style.paddingTop =
        document.querySelector('#FreeShippingBanner').getBoundingClientRect()
          .height + 'px'

      document
        .querySelector(':root')
        .style.setProperty(
          `--hh-announcement-height`,
          `${
            document
              .querySelector('#FreeShippingBanner')
              .getBoundingClientRect().height
          }px`
        )
    } else {
      document.querySelector('.js-header').style.paddingTop = 0
      document
        .querySelector(':root')
        .style.setProperty(`--hh-announcement-height`, `0px`)
    }
  }

  handleModalOpened(e) {
    document.documentElement.classList.add('overflow-hidden')
    // close all open modals except the one that was just opened
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  render() {
    return html`<slot @modalOpened="${this.handleModalOpened}"></slot>`
  }
}

customElements.define('hh-header', HHHeader)
